const RESERVED_TAGS = [
  'initialContext',
  'contextUpdate',
  'functionExecutionResult',
  'attachments',
  'follow_up_suggestions',
];

const tagPattern = RESERVED_TAGS.join('|');
const stripRegex = new RegExp(`<(${tagPattern})>[\\s\\S]*?(<\\/\\1>|$)`, 'g');

/**
 * Strip complete/unterminated reserved XML tags and trailing partial
 * fragments that could still become a reserved tag during streaming.
 */
export function stripReservedXmlTags(text) {
  if (!text) return '';
  let result = text.replace(stripRegex, '');

  const lastOpen = result.lastIndexOf('<');
  if (lastOpen === -1) return result;

  const afterOpen = result.indexOf('>', lastOpen);
  if (afterOpen !== -1) return result;

  const fragment = result.slice(lastOpen);
  if (fragment.length < 2) return result;

  if (RESERVED_TAGS.some((tag) => `<${tag}>`.startsWith(fragment) || `</${tag}>`.startsWith(fragment))) {
    return result.slice(0, lastOpen);
  }

  return result;
}
